module.exports = __webpack_public_path__ + "static/Ana-703c432c72447a31dc6cb5439c46386a.jpg";